import React from 'react';
import DepositTransfersCard from './components/DepositTransfersIndex.jsx';

const DepositTransfers = () => <DepositTransfersCard />;

export default DepositTransfers;
